module.exports = __webpack_public_path__ + "01f43047/img/mini-logo.18817ee5.svg";